import axiosInstance from '../configs/axios/axiosInstance';
import { ApiValueResponse } from '../types/apiResponse';
import { ApplicationsListResponse, CountriesResponse, LogTypesResponse, MenusResponse, OrderStatusesResponse, QuotationsResponse, RpaTemplateTypesResponse, TemplateTypesResponse, UserDetailsResponse } from '../types/commonTypes';

const CommonServices = {

    getCurrentUser: async (azureUserId: string): Promise<ApiValueResponse<UserDetailsResponse>> => {
        const params = { userToken: azureUserId };
        const response = await axiosInstance.get<ApiValueResponse<UserDetailsResponse>>(
            "General/GetUserDetails",
            { params }
        );
        return response.data;
    },

    getApplications: async (): Promise<ApiValueResponse<ApplicationsListResponse>> => {
        const response = await axiosInstance.get<ApiValueResponse<ApplicationsListResponse>>(
            'Menus/GetApplicationsList');
        return response.data;
    },

    setSelectedApplication: async (payload: any) => {
        const response = await axiosInstance.put('Menus/SetLastApplicationSelected', payload);
        return response.data;
    },

    setSelectedCountry: async (payload: { userID: string; countryID: string }) => {
        const response = await axiosInstance.put('Utilities/UpdateLastSelectedCountry', payload);
        return response.data;
    },

    getMenus: async (userId: string): Promise<ApiValueResponse<MenusResponse>> => {
        const params = { userID: userId };
        const response = await axiosInstance.get<ApiValueResponse<MenusResponse>>(
            'Menus/GetMenus',
            { params }
        );
        return response.data;
    },

    getSalesOrganization: async () => {
        const response = await axiosInstance.get('Utilities/GetSalesOrganizations');
        return response.data;
    },

    getUserCountries: async (userID: string): Promise<ApiValueResponse<CountriesResponse>> => {
        const params = { userID: userID };
        const response = await axiosInstance.get<ApiValueResponse<CountriesResponse>>(
            'Utilities/GetUserCountries',
            { params }
        );
        return response.data;
    },

    getCountries: async (): Promise<ApiValueResponse<CountriesResponse>> => {
        const response = await axiosInstance.get<ApiValueResponse<CountriesResponse>>(
            'Utilities/GetCountries'
        );
        return response.data;
    },

    getUserNotifications: async (userID: string): Promise<any> => {
        const params = { userID: userID };
        const response = await axiosInstance.get('General/xxxxx', { params: params });
        return response.data;
    },
    
    getQuotatios: async (): Promise<ApiValueResponse<QuotationsResponse>> => {
        const response = await axiosInstance.get<ApiValueResponse<QuotationsResponse>>(
            'Utilities/GetQuotations'
        );
        return response.data;
    },

    getOrderStatuses: async (): Promise<ApiValueResponse<OrderStatusesResponse>> => {
        const response = await axiosInstance.get<ApiValueResponse<OrderStatusesResponse>>(
            'Utilities/GetOrderStatuses'
        );
        return response.data;
    },

    getRpaTemplateTypes: async (): Promise<ApiValueResponse<RpaTemplateTypesResponse>> => {
        const response = await axiosInstance.get<ApiValueResponse<RpaTemplateTypesResponse>>(
            'Utilities/GetRPATemplateTypes'
        );
        return response.data;
    },

    getLogTypes: async (): Promise<ApiValueResponse<LogTypesResponse>> => {
        const response = await axiosInstance.get<ApiValueResponse<LogTypesResponse>>(
            'Utilities/GetLogTypes'
        );
        return response.data;
    },

    getTemplateTypes: async (): Promise<ApiValueResponse<TemplateTypesResponse>> => {
        const response = await axiosInstance.get<ApiValueResponse<TemplateTypesResponse>>(
            'Utilities/GetTemplateTypes'
        );
        return response.data;
    },

};

export default CommonServices;
